export class SearchObject {
  fullText: string = '';
  locationStr: string = '';
  lat: string = '';
  lng: string = '';
  firma: string = '';
  radiusKm: string = '25';
  id: number | null = null;

  // urlEncoded(): string {
  //   /* nicer, but lacks support for arrays: */
  //   // const searchParams = new URLSearchParams(
  //   //   {
  //   //     ... this,
  //   //     internexternBitmaskAll: this.internexternBitmaskAll.toString()
  //   //   }
  //   // )
  //   //
  //   // return searchParams.toString()
  //
  //   const encode = (obj: object) => {
  //     const flatted: any = flatten(obj);
  //     let params = [];
  //     for (const key in flatted) {
  //       if (
  //         flatted[key] === null
  //         || (typeof flatted[key] === 'object' && Object.keys(flatted[key]).length === 0)
  //       ) {
  //         continue;
  //       }
  //       params.push(dot2brackets(key) + '=' + encodeURIComponent(flatted[key]));
  //     }
  //     return params.join('&');
  //   };
  //
  //   const dot2brackets = (key: string) => {
  //     const arr = key.split('.');
  //     for (let i = 1; i < arr.length; i++) {
  //       arr[i] = '[' + arr[i] + ']';
  //     }
  //     return arr.join('');
  //   };
  //
  //   return encode(this);
  // }
}
